jQuery(document).ready(function ($) {
    const propertyGallery = new Swiper('.js-property-gallery', {
        loop: true,

        slidesPerView: 1,

        autoplay: true,
        delay: 4000,

        grabCursor: true,

        pagination: {
            el: '.main-details__images--pagination',

            bulletClass: 'pagination-bullet',
            bulletActiveClass: 'active',

            clickable: true,
        },

        navigation: {
            prevEl: '.main-details__images--prev',
            nextEl: '.main-details__images--next'
        },

        slideClass: 'main-details__image'
    });
});